module.exports = __webpack_public_path__ + "assets/img/bcg/bg_navy_stripes.png";